"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _RecentActivityHeader = _interopRequireDefault(require("../../RecentActivity/RecentActivityHeader"));
var _RecentActivityHeaderForm = _interopRequireDefault(require("./RecentActivityHeaderForm"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var RecentActivityHeaderWithFilterComponent = function RecentActivityHeaderWithFilterComponent() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_RecentActivityHeader["default"], null), /*#__PURE__*/_react["default"].createElement(_RecentActivityHeaderForm["default"], null));
};
var _default = exports["default"] = RecentActivityHeaderWithFilterComponent;